import React from 'react'
import CollectorsRowData from '../Collectors/CollectorsRowData'
import CollectorsRowHeading from '../Collectors/CollectorsRowHeading'
import HeaderArea from '../HeaderArea'

function FullLargestCollections() {
    return (
        <div className="TopCollectors LargestCollections">
           <HeaderArea
            title = "Largest Collections"
           />
            <div className="dataTable">
                <table>
                    <CollectorsRowHeading
                        Collector = "Collection"
                        WorksOwned = "Works Owned"
                        AvgPurchasePrice = "Avg. Purchase Price"
                        TotalPurchases = "Total Purchases"
                        BiggestPurchase =  "Biggest Purchase"
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                </table>
            </div>
        </div>
    )
}

export default FullLargestCollections
